import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class LanePropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:Lane';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'lane',
        label: i18n.lane || 'Lane',
        entries: [
          {
            id: 'laneName',
            component: () => (
              <TextFieldEntry
                id="epx-lane-name"
                label={i18n.name || 'Name'}
                value={props.name || ''}
                onChange={(val) => update('name', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
